import React from "react";
import { partiallyHideHash, pxToRem, toNumberFixed } from "@/util/common";
import { createUseStyles } from "react-jss";
import useCustomStyles from "@/hooks/useCustomStyles";
import { Button, Grid, Skeleton } from "antd-mobile";
import useCenterPopup from "@/hooks/useCenterPopup";
import Remark from "./Remark";
import { isEmpty } from "lodash";
import useCustomTranslation from "@/hooks/useTranslation";
import ApplyProportion from "./ApplyProportion";
import { AgentListData } from "@/api/type";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { isDef } from "@/util/validate";

const LevelChen: React.FC<{
	data: AgentListData;
}> = ({ data }) => {
	const classes = useStyles();
	const useClasses = useCustomStyles();
	const { t } = useCustomTranslation();
	const { userInfo } = useSelector((state: RootState) => state.auth);
	const RemarkPopup = useCenterPopup();
	const ApplyProportionPopup = useCenterPopup();
	const buttonsData = [
		{
			name: t("Remark"),
			key: "remark",
		},
	];

	const userStatusHandle = (status: number) => {
		// 1/有效 0/无效
		let result = t("Invalid");
		if (status === 1) {
			result = t("Normal");
		}
		return result;
	};

	// 判断是否显示返佣设置区域
	const shouldShowRebateSection =
		(isDef(userInfo?.income) && userInfo?.income.id === data.uid) ||
		userInfo?.id === data.uid;

	return (
		<div className={`${useClasses.cardWrap} ${classes.tinyChenWrap}`}>
			<div className="head">
				<div className="l">{data.nickname}</div>
				<div className="r">
					<span>{t("Status")}</span>
					<span className="c8BFF78">
						{userStatusHandle(+data.status)}
					</span>
				</div>
			</div>
			{!shouldShowRebateSection && (
				<div className={useClasses.rebateWrap}>
					<span>
						{t("RebateRatio")} {toNumberFixed(data.rolling, 2)}%
					</span>
					<Button
						onClick={() => ApplyProportionPopup.showPopup()}
						shape="rounded"
						style={{
							height: pxToRem(25),
							minWidth: pxToRem(72),
							fontSize: pxToRem(10),
							fontWeight: "500",
							"--border-width": "0",
							"--text-color": "#FFFFFF",
							boxShadow:
								"0px 10px 10px 1px #184DED4D, 0px 2px 4px 0px #00C2FF40 inset",
							background:
								"linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
						}}
					>
						{t("ModifyRatio")}
					</Button>
				</div>
			)}

			<Grid columns={2} gap={[0, 16]}>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("Address")}</dt>
						{!isEmpty(data) ? (
							<dd>{partiallyHideHash(data.walletAddress)}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("MyRebateClose")}</dt>
						{!isEmpty(data) ? (
							<dd>{toNumberFixed(data.totalCommission, 2)}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("MemberEffectiveBetAmount")}</dt>
						{!isEmpty(data) ? (
							<dd>{toNumberFixed(data.effective, 2)}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("LowerEffectiveBetAmount")}</dt>
						{!isEmpty(data) ? (
							<dd>{toNumberFixed(data.totalEffective, 2)}</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
				<Grid.Item>
					<dl className={useClasses.dlWrap}>
						<dt>{t("Remark")}</dt>
						{!isEmpty(data) ? (
							<dd className="tinydd">
								{data.inviteRemake || "-"}
							</dd>
						) : (
							<Skeleton
								animated
								style={{ height: pxToRem(24), width: "80%" }}
							/>
						)}
					</dl>
				</Grid.Item>
			</Grid>
			<div className={classes.buttonsWrap}>
				<Grid columns={2} gap={[15, 8]}>
					{buttonsData.map((item, index) => {
						return (
							<Grid.Item key={index}>
								<Button
									onClick={() => {
										RemarkPopup.showPopup();
									}}
									block
									shape="rounded"
									fill="outline"
									style={{
										fontSize: pxToRem(14),
										fontWeight: "400",
										"--text-color": "#82E8FF",
										"--background-color": "transparent",
										"--border-color": "#4C66C7",
									}}
								>
									{item.name}
								</Button>
							</Grid.Item>
						);
					})}
				</Grid>
			</div>
			<RemarkPopup.PopupComp
				visible={RemarkPopup.visiblePopup}
				onClose={RemarkPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					RemarkPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				<Remark onVisiblePopup={RemarkPopup.closePopup} data={data} />
			</RemarkPopup.PopupComp>

			<ApplyProportionPopup.PopupComp
				visible={ApplyProportionPopup.visiblePopup}
				onClose={ApplyProportionPopup.closePopup}
				bodyStyle={{ background: "transparent" }}
				onMaskClick={() => {
					ApplyProportionPopup.closePopup();
				}}
				className="centerPopupAfoot"
				style={{ "--max-width": "100vw" }}
			>
				{ApplyProportionPopup.visiblePopup && (
					<ApplyProportion
						onVisiblePopup={ApplyProportionPopup.closePopup}
						data={data}
					/>
				)}
			</ApplyProportionPopup.PopupComp>
		</div>
	);
};

export default LevelChen;

const useStyles = createUseStyles({
	tinyChenWrap: {
		padding: {
			top: pxToRem(15),
			bottom: pxToRem(15),
		},
		"& .head": {
			padding: {
				left: pxToRem(20),
				right: pxToRem(20),
			},
		},
		"& .adm-grid": {
			padding: {
				left: pxToRem(20),
				right: pxToRem(20),
			},
		},
	},
	buttonsWrap: {
		padding: {
			top: pxToRem(18),
		},
	},
});
